import HeroBasic from '../components/HeroBasic.js';
import Card from '../components/Card.js';
import InfoBox from '../components/InfoBox.js';
import Button from '../components/Button.js';

function BuildInfoBoxes() {
        var infoBoxData = [
                {
                        title: "Search Portal",
                        body: "Search inspection reports and notices of violation.",
                        button: {
                                text: "Open Portal",
                                href: "/portal"
                        }
                },
                {
                        title: "Why This Matters",
                        body: "Learn why environmental transparency and enforcement oversight matter.",
                        button: {
                                text: "Read More",
                                href: "/why-this-matters"
                        }
                },
                {
                        title: "Project Background",
                        body: "Learn how the FOIA effort and data collaboration developed.",
                        button: {
                                text: "Project History",
                                href: "/project-background"
                        }
                }
        ]

        var infoBoxes = infoBoxData.map((a, index) => 
                <InfoBox key={index} header={a.title}>
                        <p>{a.body}</p>
                        <Button href={a.button.href}>
                                {a.button.text}
                        </Button>
                </InfoBox>        
        )

        return <div className='grid'>{infoBoxes}</div>
}

function Home() {
        var heroTitle = "Eyes on Environmental Enforcement Project";
        var heroSubtitle = "A public-interest transparency initiative exposing environmental enforcement records obtained through FOIA."

        var cardHeader = "About the Project"
        var infoBoxes = BuildInfoBoxes()

        return (
                <div className="Home">
                        <HeroBasic title={heroTitle} subtitle={heroSubtitle}/>
                        <Card header={cardHeader}>
                                <p>The Eyes on Environmental Enforcement Project exposes previously hidden government documents, primarily from EPA, for use in tracking enforcement (or lack of enforcement) under the Clean Air Act (CAA), Clean Water Act (CWA), and Resource Conservation and Recovery Act (RCRA). EPA has never fully digitized or published these documents, but PEER has obtained them via Freedom of Information Request. PEER recently documented the collapse of enforcement (<a href="https://peer.org/under-trump-epas-enforcement-of-environmental-laws-collapses-report-finds/">link</a>) under EPA Administrator Lee Zeldin. The Eyes on Environmental Enforcement Project is a new digital resource that can help the public, NGOs and academia understand exactly where enforcement may have stopped in its tracks. The Eyes on Environmental Enforcement Portal (<a href="https://www.eyesonenforcement.org/#/portal">link</a>) provides search capabilities for inspection reports and notices of violation. The documents can be supporting evidence for citizen suits. PEER is collaborating with the Environmental Data & Governance Initiative (<a href="https://envirodatagov.org/">EDGI</a>).</p>
                                
                                <p>The Eyes on Environmental Enforcement project will be adding more documents, analysis and other features to this page in the future. Step 1 is getting documents posted online.</p>
                                {infoBoxes}
                        </Card>
                </div>
        );
}

export default Home;
